module.exports = __webpack_public_path__ + "static/media/INTGEN.8cc32015.png";